import React from "react";

export default function PageAboutBio() {
  return (
    <section className="about-bio">
      <p>
        Hello! I am Juan Carlos Sánchez Laguna, a personal Panamanian trainer.
        based in Porto, Portugal. My passion for fitness and sports has led me
        to dedicate my life to helping others achieve their goals of health and
        well-being.do to dedicate my life to helping others achieve your health
        and wellness goals.
      </p>
      <p>
        With experience in various sports and disciplines, I strive to create
        personalized training programs that adapt to the unique needs of each
        client. I firmly believe in the power of exercise to transform lives and
        I am committed to providing support and motivation every step of the
        way.
      </p>
    </section>
  );
}
